import type { FC } from 'react';
import React, { useContext } from 'react';

import Button from '../../button';
import { convertLegacyProps } from '../../button/buttonHelpers';
import { ModalContext } from '../context';
import type { ModalProps } from '../interface';

export interface NormalCancelBtnProps extends Pick<ModalProps, 'cancelButtonProps' | 'onCancel' | 'cancelType'> {
  cancelTextLocale?: React.ReactNode;
}

const NormalCancelBtn: FC = () => {
  const { cancelButtonProps, cancelTextLocale, cancelType, onCancel } = useContext(ModalContext);
  return (
    <Button 
      {...convertLegacyProps(cancelType)}
      onClick={onCancel} 
      {...cancelButtonProps}
    >
      {cancelTextLocale}
    </Button>
  );
};

export default NormalCancelBtn;
